import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { appendSerialisedHttpParams, AuditQueryResult, deserialiseAuditQueryResults, ENVIRONMENT, HateoasMultipleResponseObject, markAsBackgroundServiceCall, ReportRunService, ReportSpecificationService } from '@scisys-uim/uim-common';
import { Asset, AssetRevision } from 'assets-model';
import { Observable } from 'rxjs';
import { AssetServiceBase } from './asset.service.base';


@Injectable({
  providedIn: 'root'
})
export class AssetService extends AssetServiceBase {
  constructor(protected reportRunService: ReportRunService,
    protected reportSpecificationService: ReportSpecificationService,
    http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment, reportRunService, reportSpecificationService);
  }

  public findAuditHistory(assetId: number): Observable<any[]> {
    return this.deserialiseAssetAuditQueryResult(this.http.get<AuditQueryResult<Asset>[]>(this.serviceBaseUrl + '/findAuditHistory/' + assetId));
  }

  protected deserialiseAssetAuditQueryResult(response: Observable<AuditQueryResult<Asset>[]>): Observable<any[]> {
    return deserialiseAuditQueryResults(response, r => new AssetRevision(r));
  }

  findExistingAttributeValues(attributeName: string, text?: string, assetType?: string, backgroundServiceCall?: boolean): Observable<string[]> {
    var params: HttpParams = appendSerialisedHttpParams(text, 'text');
    params = appendSerialisedHttpParams(assetType, 'assetType', params);
    return this.http.get<string[]>(this.serviceBaseUrl + '/findExistingAttributeValues/' + attributeName, {
      headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null,
      params: params
    });
  }

  public getAssetsFromFile(file: File): Observable<HateoasMultipleResponseObject<Asset>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    var params = new HttpParams();
    return this.deserialiseMultipleResponse(this.http.post<HateoasMultipleResponseObject<Asset>>(this.serviceBaseUrl + "/getAssetsFromFile", formData, { params: params }));
  }

  public importAll(rows: Asset[]): Observable<HateoasMultipleResponseObject<Asset>> {
    var params = new HttpParams();
    return this.deserialiseMultipleResponse(this.http.post<HateoasMultipleResponseObject<Asset>>(this.serviceBaseUrl + "/importAll", this.serialiseMultiple(rows), {
      params: params
    }));
  }

}